import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { Tab } from '@/components/ui/tab';

export function Tabs() {
  const intl = useIntl();
  const location = useLocation();

  const pathParts = location.pathname.split('/');
  const activeTab = pathParts[pathParts.length - 1];

  return (
    <div className="flex items-center gap-2">
      <Tab
        title={intl.formatMessage({ defaultMessage: 'Automation' })}
        to="automation"
        isActive={activeTab === 'automation'}
      />
      <Tab
        title={intl.formatMessage({ defaultMessage: 'Channel Enablement' })}
        to="channels"
        isActive={activeTab === 'channels'}
      />
    </div>
  );
}
